import React from 'react';
import PropTypes from 'prop-types';

function PreFooter({ alertsInfo }) {
  const { maxDocumentsPerEmail } = alertsInfo;

  return (
    <div className="create-alert-dialog-pre-footer">
      Email alerts will be limited in size and restricted to {maxDocumentsPerEmail} records or 10Mb (depending on which is reached first)
    </div>
  );
}

PreFooter.propTypes = {
  alertsInfo: PropTypes.object.isRequired,
};

export default PreFooter;
